<template>
  <div class="nav" id="top">
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <router-link class="navbar-item" to="/">
          <img src="~@/assets/img/logo-header@2x.png" width="191" height="23">
        </router-link>

        <a role="button" class="navbar-burger" @click="showNav = !showNav" :class="{ 'is-active': showNav }">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div class="navbar-menu" :class="{ 'is-active': showNav }">
        <div class="navbar-start">
          <router-link class="navbar-item is-uppercase" to="/ipad">
            iPad
          </router-link>
          <router-link class="navbar-item is-uppercase" to="/iphone">
            iPhone
          </router-link>
          <!-- <router-link class="navbar-item is-uppercase" to="/faq">
            FAQ
          </router-link> -->
          <router-link class="navbar-item is-uppercase" to="/blog">
            Blog
          </router-link>
        </div>

        <div class="navbar-end">
          <!-- navbar items -->
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'navbar',
  props: {
    showNav: false
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Nav.vue